import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // 👉 Replace with real auth logic
  const isLoggedIn = !!localStorage.getItem('token');

  if (isLoggedIn) {
    return true;
  }

  // redirect to login
  return router.createUrlTree(['/auth/login']);
};
